import { getClaimOwnerCapacityBandFeature } from '@dispatch/shared/services';
import { isEmpty } from 'lodash';
import { useQuery } from '../useQuery';

/**
 * Per-tenant kill-switch for the Claim Owner capacity band on the Scheduler
 * View resource row (ADO #104914).
 *
 * Defaults to `false` while the query is disabled, in flight, errored, or when
 * the configuration key is absent, so an unresolved flag leaves the Scheduler
 * exactly as it is today rather than optimistically exposing the band.
 */
export const useGetClaimOwnerCapacityBandFeature = (
  tenantId: string,
  enabled = true
) => {
  const { data, status, refetch } = useQuery(
    ['claim-owner-capacity-band-feature', tenantId],
    () => getClaimOwnerCapacityBandFeature(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    feature: data || false,
    featureStatus: status,
    fetchFeature: refetch,
  };
};
